import React, { createContext, useState } from 'react';

// Create a Context for the totalPrice
export const PriceContext = createContext();

// Create a Provider component
export const PriceProvider = ({ children }) => {
  const [totalPrice, setTotalPrice] = useState(0); // Set initial total price to 0

  return (
    <PriceContext.Provider value={{ totalPrice, setTotalPrice }}>
      {children}
    </PriceContext.Provider>
  );
};
